import React from 'react';
import { BookOpen, Headphones, Calendar } from 'lucide-react';
export function PackageSection() {
  const items = [{
    icon: BookOpen,
    title: 'E-book Hogar Blindado (PDF)',
    description: 'El mapa completo, explicado fácil.'
  }, {
    icon: Headphones,
    title: 'Audio Guía',
    description: 'Para seguirlo sin leer, mientras haces otras cosas.'
  }, {
    icon: Calendar,
    title: 'Calendario 14 días',
    description: 'Rutina simple para evitar reinfestación.'
  }];
  return <section className="py-16 bg-white" data-id="element-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="bg-[#e8f4fc] rounded-3xl p-8 md:p-12 border border-[#4a90c2]/20" data-id="element-102">
          <div className="text-center mb-10" data-id="element-103">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1e4d7b]" data-id="element-104">
              Todo lo que incluye tu acceso
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-105">
            {items.map((item, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-106">
                <div className="w-16 h-16 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-4 text-[#4a90c2]" data-id="element-107">
                  <item.icon className="h-8 w-8" data-id="element-108" />
                </div>
                <h3 className="font-bold text-[#1e4d7b] mb-2" data-id="element-109">{item.title}</h3>
                <p className="text-sm text-gray-600" data-id="element-110">{item.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}